<template>
  <div class="mockup-preview" @click="change()">
    <div class="header" v-if="!hideHeader">
      {{ material }}
    </div>
    <div :style="styles" class="content-slider">
      <img
        v-for="(stamp, index) in stamps"
        :key="index"
        :src="govinci(stamp)"
        :width="width"
        :height="height"
        :style="styleImg"
        :class="i === index ? 'active' : ''"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    material: String,
    stamps: {
      type: Array,
      required: false,
      default: null,
    },
    hideHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: Number,
      required: false,
      default: 200,
    },
    height: {
      type: Number,
      required: false,
      default: 200,
    },
  },
  data() {
    return {
      i: 0,
    };
  },
  computed: {
    styles() {
      return { width: this.width + "px", height: this.height + "px" };
    },
    styleImg() {
      return { left: this.width + "px" };
    },
  },
  methods: {
    change() {
      if (this.i < this.stamps.length - 1) this.i++;
      else this.i = 0;
    },
    govinci(stamp) {
      const { material } = this;
      if (!material) return;
      let url = `https://preview2nc.gocase.com.br/${material}/material`;
      if (stamp) url = url + `?stamp=${stamp}`;
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.mockup-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .header {
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
  }

  .content-slider {
    position: relative;
    overflow: hidden;

    img {
      position: absolute;
      transition: 0.2s;
    }

    img.active {
      left: 0 !important;
    }
  }
}
</style>
